import { CREDIT_LIMITS_FORM_FIELDS as a } from "@perxis-auto/credit-sdk";
import { isDefined as o } from "@perxis-auto/shared";
import { APP as r } from "./app.js";
const _ = `${r.name}:events`, n = {
  Initialized: "initialized",
  FormFieldValueChanged: "form_field_value_changed",
  FinanceProgramSelected: "finance_program_selected",
  ButtonClicked: "button_clicked"
}, i = {
  RESET_FORM: "reset-form-button",
  CONFIRM_FORM: "confirm-form-button"
}, E = {
  CREDIT_TYPE_CHANGED: {
    event: "customEvent",
    eventCategory: "avn-credit",
    eventAction: "use",
    eventLabel: "type"
  },
  CREDIT_DOWN_PAYMENT_CHANGED: {
    event: "customEvent",
    eventCategory: "avn-credit",
    eventAction: "use",
    eventLabel: "payment"
  },
  CREDIT_RESIDUAL_PAYMENT_CHANGED: {
    event: "customEvent",
    eventCategory: "avn-credit",
    eventAction: "use",
    eventLabel: "remaining-payment"
  },
  CREDIT_PERIOD_CHANGED: {
    event: "customEvent",
    eventCategory: "avn-credit",
    eventAction: "use",
    eventLabel: "term"
  },
  CREDIT_PROGRAM_SELECTED: {
    event: "customEvent",
    eventCategory: "avn-credit",
    eventAction: "click",
    eventLabel: "program"
  },
  CREDIT_CONFIRM: {
    event: "customEvent",
    eventCategory: "avn-credit",
    eventAction: "click",
    eventLabel: "apply"
  },
  CREDIT_RESET: {
    event: "customEvent",
    eventCategory: "avn-credit",
    eventAction: "click",
    eventLabel: "reset"
  }
}, C = [
  {
    rule: (t, e) => t === n.FormFieldValueChanged && e.fieldId === a.type,
    analyticEvent: E.CREDIT_TYPE_CHANGED
  },
  {
    rule: (t, e) => t === n.FormFieldValueChanged && (e.fieldId === a.downPayment || e.fieldId === a.downPaymentAmount),
    analyticEvent: E.CREDIT_DOWN_PAYMENT_CHANGED
  },
  {
    rule: (t, e) => t === n.FormFieldValueChanged && (e.fieldId === a.residualPayment || e.fieldId === a.residualPaymentAmount),
    analyticEvent: E.CREDIT_RESIDUAL_PAYMENT_CHANGED
  },
  {
    rule: (t, e) => t === n.FormFieldValueChanged && e.fieldId === a.numberOfPeriods,
    analyticEvent: E.CREDIT_PERIOD_CHANGED
  },
  {
    rule: (t, e) => t === n.FinanceProgramSelected && o(e.program),
    analyticEvent: E.CREDIT_PROGRAM_SELECTED
  },
  {
    rule: (t, e) => t === n.ButtonClicked && e.id === i.CONFIRM_FORM,
    analyticEvent: E.CREDIT_CONFIRM
  },
  {
    rule: (t, e) => t === n.ButtonClicked && e.id === i.RESET_FORM,
    analyticEvent: E.CREDIT_RESET
  }
];
export {
  C as APP_ANALYTIC_EVENTS,
  n as APP_EVENTS,
  _ as APP_EVENTS_CHANNEL,
  i as APP_EVENT_BUTTONS
};
